export const queryKeys = {
  NATIONAL_CERTIFICATE_DIRECTION: 'national-certificate-directions',
  NATIONAL_CERTIFICATE_SUBJECTS: 'national-certificate-subjects',
  NATIONAL_CERTIFICATE_TESTS: 'national-certificate-tests'
};
